import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12h18","key":"svg-0"}],["path",{"d":"M12 21v-18","key":"svg-1"}],["path",{"d":"M7.5 7.5l9 9","key":"svg-2"}],["path",{"d":"M7.5 16.5l9 -9","key":"svg-3"}]]

const IconNorthStar = createReactComponent('outline', 'north-star', 'NorthStar', __iconNode);

export default IconNorthStar;